import { Controller } from "stimulus";

export default class extends Controller {
  reset(event) {
    event.preventDefault();
    this.element.reset();
  }
}
